'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { trackNavigation } from '@/lib/analytics';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export function Header() {
  const pathname = usePathname();
  const isQuizPage = pathname === '/quiz';
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigation = (destination: string) => {
    trackNavigation(destination);
    setIsMenuOpen(false);
  };

  const handleQuizClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isQuizPage) {
      // If we're on the quiz page, reload the page to restart the quiz
      window.location.reload();
    } else {
      // Otherwise, navigate to the quiz page
      window.location.href = '/quiz';
    }
    setIsMenuOpen(false);
  };

  const NavLinks = () => (
    <>
      <a
        href="/quiz"
        className="text-sm font-medium transition-colors hover:text-primary"
        onClick={handleQuizClick}
      >
        {isQuizPage ? 'Start New Quiz' : 'Find Your Perfect Dog'}
      </a>
      <Link
        href="/breeds"
        className="text-sm font-medium transition-colors hover:text-primary"
        onClick={() => handleNavigation('breeds')}
      >
        Browse Breeds
      </Link>
      <Link
        href="/blog"
        className="text-sm font-medium transition-colors hover:text-primary"
        onClick={() => handleNavigation('blog')}
      >
        Blog
      </Link>
      <Link
        href="/about"
        className="text-sm font-medium transition-colors hover:text-primary"
        onClick={() => handleNavigation('about')}
      >
        About
      </Link>
      <Link
        href="/contact"
        className="text-sm font-medium transition-colors hover:text-primary"
        onClick={() => handleNavigation('contact')}
      >
        Contact
      </Link>
    </>
  );

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white">
      <div className="container mx-auto flex h-16 items-center justify-between px-4 max-w-7xl">
        <Link 
          href="/" 
          className="flex items-center space-x-2"
          onClick={() => handleNavigation('home')}
        >
          <span className="font-bold text-xl">DogPicker</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <NavLinks />
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-md hover:bg-gray-100"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden border-t bg-white">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <NavLinks />
          </nav>
        </div>
      )}
    </header>
  );
} 